import {useMutation} from '@tanstack/react-query';
import {getExamAuthorization} from '../../services/getExamAuthorization';

export function useGetExamAuthorizationMutation() {
	return useMutation({
		mutationFn: getExamAuthorization,
	});
}
